export default {
      id: "staff-usage",
      viewBox: "0 0 69.97 69.97",
      url: __webpack_public_path__ + "sprite.svg#staff",
      toString: function () {
        return this.url;
      }
    }